import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { selectBusbarDefaults, updateDefaults } from '../../../../redux/panelDetailSlice';

export default function BusbarSection() {
  const dispatch = useDispatch();
  const busbar = useSelector(selectBusbarDefaults);

  const handleChange = (field, value) => {
    dispatch(updateDefaults({
      section: 'busbarCompartment',
      changes: { [field]: typeof value === 'string' && !isNaN(parseFloat(value)) ? parseFloat(value) : value },
    }));
  };

  return (
    <div className="detail-section-content">
      <div className="detail-field">
        <label>Bara Yuksekligi (cm)</label>
        <input
          type="number"
          step="5"
          min="10"
          value={busbar.height}
          onChange={e => handleChange('height', e.target.value)}
        />
      </div>

      <div className="detail-field">
        <label>Bara Genisligi</label>
        <div className="detail-checkbox-col">
          <label>
            <input
              type="checkbox"
              checked={busbar.widthMode === 'METER_ONLY' || busbar.widthMode === 'BOTH'}
              onChange={e => {
                const meterChecked = e.target.checked;
                const distChecked = busbar.widthMode === 'DIST_ONLY' || busbar.widthMode === 'BOTH';
                if (meterChecked && distChecked) handleChange('widthMode', 'BOTH');
                else if (meterChecked) handleChange('widthMode', 'METER_ONLY');
                else if (distChecked) handleChange('widthMode', 'DIST_ONLY');
                else handleChange('widthMode', 'METER_ONLY'); // en az biri secili olmali
              }}
            />
            Sayac bolmesi genisligini kapsa
          </label>
          <label>
            <input
              type="checkbox"
              checked={busbar.widthMode === 'DIST_ONLY' || busbar.widthMode === 'BOTH'}
              onChange={e => {
                const distChecked = e.target.checked;
                const meterChecked = busbar.widthMode === 'METER_ONLY' || busbar.widthMode === 'BOTH';
                if (meterChecked && distChecked) handleChange('widthMode', 'BOTH');
                else if (meterChecked) handleChange('widthMode', 'METER_ONLY');
                else if (distChecked) handleChange('widthMode', 'DIST_ONLY');
                else handleChange('widthMode', 'METER_ONLY');
              }}
            />
            Dagitim bolmesi genisligini kapsa
          </label>
        </div>
      </div>
    </div>
  );
}
